import React, {
    useState, useEffect, useCallback, useContext
} from 'react'
import { Formik, Form } from 'formik'
import { toast } from 'react-toastify'

import { FaFilePdf } from 'react-icons/fa'

import { api, authHeaders } from '~/services/api'

import { downloadRelatorioJasper } from '~/util/file'

import { Button, Select } from '~/components/Form'
import Spinner from '~/components/Spinner'

import Card from '~/components/Card'

import { Container, ButtonContainer } from './styles'

import Yup from '~/services/yup'
import { GlobalContext } from '~/contexts/GlobalContext'

const validation = Yup.object().shape({
    ano: Yup.string().ensure().required('Informe o ano.')
})

export default function () {
    const { user } = useContext(GlobalContext)

    const [anos, setAnos] = useState([])

    useEffect(() => {
        const currentYear = new Date().getFullYear()
        const listaAnos = []

        for (let i = currentYear; i >= 2020; i--) {
            listaAnos.push({
                label: i,
                value: i
            })
        }

        setAnos(listaAnos)
    }, [])

    const handleSubmit = useCallback(async (values, { resetForm }) => {
        const { ano } = values

        const { associado: { pessoa } } = await api.get(`pessoa/${user.pessoa.id}`, authHeaders())

        const crm = pessoa.documentos.find(doc => doc.tipo_documento.id === 3).identificador

        if (!crm) {
            toast.error('Usuário sem CRM cadastrado.')
            return
        }

        const params = {
            competencia: `${ano.value}-01-01|${ano.value}-12-01`,
            crm
        }

        const contribuicoes = await api.get('contribuicao', {
            params,
            ...authHeaders()
        })

        if (contribuicoes.length === 0) {
            toast.info('Você não possui contribuições referente ao ano informado.')
            return
        }

        const pendentes = contribuicoes.filter(c => !c.status)

        if (pendentes.length > 0) {
            toast.error('Você possui contribuições em aberto, favor quitar as mesmas, para que seja possível gerar a declaração.')
            return
        }

        const tipo_pagamento = contribuicoes[0].tipo_pagamento.id

        let nomeRelatorio

        if (tipo_pagamento === 4 || tipo_pagamento === 5 || tipo_pagamento === 7) {
            nomeRelatorio = 'RelatorioDeclaracaoSindicatoAnuidade'
        } else {
            nomeRelatorio = 'RelatorioDeclaracaoSindicalMensalidade'
        }

        try {
            const response = await api.post('relatorio', {
                relatorio: nomeRelatorio,
                parametros: {
                    ano: ano?.value,
                    crm
                }
            }, {
                ...authHeaders(),
                responseType: 'blob'
            })

            downloadRelatorioJasper(response, 'RelatorioDeclaracaoAnualSindicato')

            resetForm()
        } catch (e) {
            console.log(e)
            toast.error('Erro ao gerar a declaração.')
        }
    }, [])

    return (
        <Container>
            <main className="animated fadeIn faster">
                <Card>
                    <h1>Declaração sindicato anual</h1>

                    <Formik
                        initialValues={{ ano: '' }}
                        validationSchema={validation}
                        onSubmit={handleSubmit}
                        enableReinitialize
                        containerStyle={{ gridArea: 'form' }}
                    >
                        {({
                            isSubmitting, setFieldValue
                        }) => (
                            <Form>
                                <Select
                                    name="ano"
                                    label="Ano"
                                    onChange={(selected, meta) => setFieldValue(meta.name, selected)}
                                    options={anos}
                                    selectionMode="range"
                                    containerStyle={{ gridArea: 'f1' }}
                                />

                                <Spinner
                                    visible={isSubmitting}
                                    label="Gerando declaração..."
                                    containerStyle={{ gridArea: 'spinner' }}
                                />

                                <ButtonContainer>
                                    <Button
                                        type="submit"
                                        loading={isSubmitting}
                                        className="transparent"
                                    >
                                        Gerar declaração
                                        <FaFilePdf size={20} />
                                    </Button>
                                </ButtonContainer>
                            </Form>
                        )}
                    </Formik>
                </Card>
            </main>
        </Container>
    )
}
